import styled from 'styled-components';
import { rem } from 'polished';

const Flex = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.font.primary};
`;

const Cell = styled(Flex)``;

export const LeftCell = styled(Cell)`
  flex-direction: row;
  align-items: center;
`;

export const RightCell = styled(Cell)`
  justify-content: center;
  margin-left: auto;
`;

export const Label = styled(Flex)`
  font-size: ${rem(14)};
  letter-spacing: 0.2px;
`;

export const Subtitle = styled(Flex)`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${rem(14)};
  letter-spacing: 0.1px;
`;

export const Price = styled(Flex)`
  font-size: ${rem(14)};
  width: ${rem(65)};
  justify-content: flex-end;
  color: ${({ theme }) => theme.color.primary};
  font-weight: bold;
`;

export const CountSelect = styled(Flex)`
  margin-right: ${rem(10)};
`;



// WEBPACK FOOTER //
// ./src/containers/Passengers/TarrifPicker/Row.js